module.exports = __webpack_public_path__ + "img/sololearnJS.8b0ba497.webp";